import React, { useState } from 'react';
import wechatQR from '../../assets/wechat-qr.png';
import { useAppStore } from '../../store';

interface SidebarProps {
  activeTab: 'search' | 'favorites' | 'trending' | 'feedback' | 'payment';
  onTabChange: (tab: 'search' | 'favorites' | 'trending' | 'feedback' | 'payment') => void;
}

const Sidebar: React.FC<SidebarProps> = ({ activeTab, onTabChange }) => {
  const [showWechatQR, setShowWechatQR] = useState(false);
  const { user } = useAppStore();

  const menuItems = [
    {
      id: 'trending' as const,
      icon: 'fas fa-fire',
      label: 'GitHub Trending',
      description: '今日热门项目'
    },
    {
      id: 'search' as const,
      icon: 'fas fa-search',
      label: '项目搜索',
      description: '搜索GitHub项目'
    },
    {
      id: 'favorites' as const,
      icon: 'fas fa-heart',
      label: '我的收藏',
      description: '收藏的项目'
    },
    {
      id: 'payment' as const,
      icon: 'fas fa-crown',
      label: '会员 / 支付',
      description: '查看会员状态'
    }
  ];

  return (
    <div className="main-sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <i className="fab fa-github"></i>
          <span className="sidebar-title">GitHub AI</span>
        </div>
      </div>
      
      <nav className="sidebar-nav">
        <ul className="sidebar-menu">
          {menuItems.map((item) => (
            <li key={item.id} className="sidebar-menu-item">
              <button
                className={`sidebar-menu-link ${activeTab === item.id ? 'active' : ''}`}
                onClick={() => onTabChange(item.id)}
                title={item.description}
              >
                <div className="sidebar-menu-icon">
                  <i className={item.icon}></i>
                </div>
                <div className="sidebar-menu-content">
                  <span className="sidebar-menu-label">{item.label}</span>
                  <span className="sidebar-menu-desc">{item.description}</span>
                </div>
                <div className="sidebar-menu-arrow">
                  <i className="fas fa-chevron-right"></i>
                </div>
              </button>
            </li>
          ))}
        </ul>
      </nav>

      {/* 反馈入口 */}
      <div className="feedback-link">
        <button
          className={`sidebar-menu-link ${activeTab === 'feedback' ? 'active' : ''}`}
          onClick={() => onTabChange('feedback')}
          title="问题反馈"
        >
          <div className="sidebar-menu-content">
            <span className="sidebar-menu-label">问题反馈</span>
          </div>
        </button>
      </div>

      <div className="sidebar-footer">
        <div className="sidebar-version">
          <i className="fas fa-code-branch"></i>
          <span>v2.0</span>
          {user && (
            <div className="api-status-indicators">
              <div
                className={`status-dot ${user.has_qianwen_key ? 'configured' : 'not-configured'}`}
                title={`LLM模型API: ${user.has_qianwen_key ? '已配置' : '未配置'}`}
              ></div>
              <div
                className={`status-dot ${user.has_github_token ? 'configured' : 'not-configured'}`}
                title={`GitHub Token: ${user.has_github_token ? '已配置' : '未配置'}`}
              ></div>
            </div>
          )}
        </div>
        <div
          className="wechat-contact"
          onMouseEnter={() => setShowWechatQR(true)}
          onMouseLeave={() => setShowWechatQR(false)}
        >
          <i className="fab fa-weixin"></i>
          <span>微信联系</span>
          {showWechatQR && (
            <div className="wechat-qr-popup">
              <img src={wechatQR} alt="微信二维码" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;

